import React from "react";
import { Link } from "react-router-dom";
import TechbucketWhite from "../../../images/techbucket-white.png";

const Footer = () => {
  return (
    <section className="gradient-background-placeholder-bottom">
      <div className="p-3 flex flex-row justify-between items-end flex-1">
        <div className="flex flex-col justify-center">
          <p className="text-white font-bold text-xs lg:text-lg lg:pb-4">
            Techbucket Ltd.
          </p>
          <p className="text-white font-light text-xs lg:text-lg lg:pb-2">
            +41 77 40 440 19
          </p>
          <p className="text-white font-light text-xs lg:text-lg lg:pb-2">
            info@techbucket.ch
          </p>
        </div>
        <div className="flex flex-col justify-center items-center">
          <img
            src={TechbucketWhite}
            className="nav-bar-logo"
            alt="Techbucket"
          />
          <p className="text-white font-light text-xs lg:text-lg text-center">
            © {new Date().getFullYear()} Techbucket. All rights reserved.
          </p>
          <div className="mt-4 flex flex-wrap gap-4 justify-center">
            <Link
              className="text-white font-light text-xs lg:text-sm underline underline-offset-2 hover:text-primary"
              to="/impressum"
            >
              Impressum
            </Link>
            <span className="text-divider hidden sm:inline">|</span>
            <Link
              className="text-white font-light text-xs lg:text-sm underline underline-offset-2 hover:text-primary"
              to="/agb"
            >
              AGB
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export { Footer };
